module.exports = __webpack_public_path__ + "static/media/18.013.350c010b.webp";